import React from "react";

import Card from "common/components/Card/Card.jsx";
import CardHeader from "common/components/Card/CardHeader.jsx";
import CardIcon from "common/components/Card/CardIcon.jsx";
import CardBody from "common/components/Card/CardBody.jsx";

import Table from "common/components/Table/Table.jsx";

// @material-ui/core components
import AttachMoney from "@material-ui/icons/AttachMoney";

import loadContent from "core-module/hoc/loadContent";

import dashboardStyle from "assets/jss/material-dashboard-pro-react/views/dashboardStyle";
import withStyles from "@material-ui/core/styles/withStyles";

const importedStyle = dashboardStyle;

const styles = {
  cardCategory: importedStyle.cardCategory,
  cardTitle: importedStyle.cardTitle,
  datainfo: {
    ...importedStyle.cardTitle,
    textAlign: "right",
    paddingRight: "20px"
  },
  cardIconTitle: {
    ...importedStyle.cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  },
  labelHorizontal: {
    justifyContent: "center"
  },
  containerLine: {
    marginTop: "20px"
  },
  editButton: {
    textAlign: "right",
    margin: "10px"
  },
  maxHeight: {
    maxHeight: "400px"
  }
};

const LongDistanceHistory = props => {
  const { classes } = props;
  return (
    <Card>
      <CardHeader color="primary" icon>
        <CardIcon color="primary">
          <AttachMoney />
        </CardIcon>
        <h4 className={classes.cardIconTitle}>
          International Allowance Transactions History
        </h4>
      </CardHeader>
      <CardBody>
        <Table
          tableCustomClasses={classes.maxHeight}
          tableHead={["Date", "Amount"]}
          tableData={props.getList(
            (oGet, id) => [oGet("ts"), "$ " + oGet("amount")],
            () => [["No recent transactions", ""]]
          )}
        />
      </CardBody>
    </Card>
  );
};

export default withStyles(styles)(
  loadContent(
    "user.session/billingpackage.props/voipldhistory",
    LongDistanceHistory
  )
);
